import React from 'react';
import './Welcome.css';

export default function Welcome({ onContinue }) {
  return (
    <div className="welcome">
      <div className="welcome-content">
        <h1>welcome to urnotniche.com</h1>
        
        <div className="welcome-text">
          <p>There are many people just like you</p>
        </div>

        <button className="continue-btn" onClick={onContinue}>
          continue
        </button>
      </div>
    </div>
  );
}
